interface Props {
  name: string;
  photoUrl?: string;
  size?: 'sm' | 'md' | 'lg';
}

const SIZE: Record<NonNullable<Props['size']>, { box: string; text: string }> = {
  sm: { box: 'h-8 w-8', text: 'text-xs' },
  md: { box: 'h-10 w-10', text: 'text-sm' },
  lg: { box: 'h-14 w-14', text: 'text-base' }
};

function initials(name: string): string {
  const parts = name
    .trim()
    .split(/\s+/)
    .filter(Boolean);
  if (parts.length === 0) return '?';
  if (parts.length === 1) return parts[0]!.slice(0, 2).toUpperCase();
  return (parts[0]![0]! + parts[parts.length - 1]![0]!).toUpperCase();
}

function hueFor(name: string): number {
  let h = 0;
  for (let i = 0; i < name.length; i++) h = (h * 31 + name.charCodeAt(i)) >>> 0;
  return h % 360;
}

export function Avatar({ name, photoUrl, size = 'md' }: Props) {
  const cls = SIZE[size];
  if (photoUrl) {
    return (
      <img
        src={photoUrl}
        alt={`${name} photo`}
        className={`${cls.box} shrink-0 rounded-full object-cover ring-1 ring-black/5 dark:ring-white/10`}
        loading="lazy"
      />
    );
  }
  const hue = hueFor(name);
  return (
    <div
      className={`${cls.box} ${cls.text} shrink-0 inline-flex items-center justify-center rounded-full font-medium text-white select-none`}
      style={{ backgroundColor: `hsl(${hue} 45% 50%)` }}
      aria-hidden="true"
    >
      {initials(name)}
    </div>
  );
}
